import { Scope } from 'yatte'

export function getKeyOfOpt (opt, optionKeyName) {
  if (opt) {
    if (typeof opt === 'object') {
      if ('id$' in opt) {
        return opt.id$
      }
      if (optionKeyName && (optionKeyName in opt)) {
        return String(opt[optionKeyName])
      }
    }
    return String(opt)
  }
  return ''
}

export function lookupOption (key, rtOptions) {
  if (key) {
    const option = rtOptions.find(opt => isMatch(opt, key))
    return option
  }
}

export function isMatch (option, keyValue, keyName = 'id$') {
  return (option !== undefined) && (option !== null) && (option[keyName] === keyValue || option === keyValue)
  // the last case (... || option === keyValue) is to accommodate the situation where a selection list answer
  // is (at this point in execution) a simple list of strings, rather than a list of String wrappers as
  // would normally be expected. (See bug #650.)
  // A better way to address this might be to catch it somewhere earlier:
  //   * detect selection and selection list answers in refreshScope() that have not yet been converted from plain
  //     strings or string arrays, and convert them there into appropriate wrapper objects
  //   * or detect them clear back in overlayData() and fix them up at that point
  // The point of this comment is: a proper answer for a SINGLE selection variable is a wrapped primitive,
  // and a proper answer for a selection LIST variable is an array of wrapped primitives. Without that proper answer,
  // any attempt to dereference the selection answer and drill down to a property of it, will fail.
}

export function arrayContainsKey (array, keyValue, keyName = 'id$') {
  return array.findIndex(v => isMatch(v, keyValue, keyName)) >= 0
}

export function renderOptionList (optionsToRender, needsBlank, context, renderFunc) {
  const optionArray = ForceArray(optionsToRender, needsBlank)
  if (needsBlank) {
    optionArray.unshift('')
  }
  // we used to render options in a single list context, all at once:
  // const listScope = Scope.pushList(optionArray, context.scope)
  // return optionArray.map((opt, index) => renderFunc(opt, Scope.pushListItem(index, listScope)))

  // now we render options individually -- the thought being, to facilitate async or out-of-order loading...
  // but I don't think this is making any difference, because I don't think this code path is active in that case!
  const parentScope = context.scope
  return optionArray.map(opt => renderFunc(opt, Scope.pushObject(opt, parentScope)))
}

/**
 * ensures the array parameter is, in fact, an array, and returns it.  If the immutable parameter is true,
 * it will always return a copy of the array rather than the original array.
 * 
 * @param {*} array the item that is expected to be an array
 * @param {*} immutable whether to return the original array or a copy of it
 * @returns an array that is either the same as, or a copy of, the original array
 */
function ForceArray (array, immutable) {
  return (array && Array.isArray(array))
    ? immutable
      ? [...array]
      : array
    : []
}
